// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_copied = /** @type {(inputs: {}) => string} */ () => {
	return `Copied to clipboard`
};

const zh_copied = /** @type {(inputs: {}) => string} */ () => {
	return `已复制到剪贴板`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const copied = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.copied(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("copied", locale)
	if (locale === "en") return en_copied(inputs)
	return zh_copied(inputs)
};